import { Box, Modal } from "@mui/material";
import React from "react";

interface IGenericModalProps {
	open: boolean;
	onClose: (value: boolean) => void;
	title: string;
	children: React.ReactNode;
}

export const GenericModal: React.FC<IGenericModalProps> = (props) => {
	const style = {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		width: "80%",
		bgcolor: "background.paper",
		borderRadius: "10px",
		boxShadow: 24,
		p: 4,
	};
	return (
		<div>
			<Modal open={props.open} onClose={props.onClose}>
				<Box sx={style}>
					<div style={{ maxHeight: "90vh", overflow: "auto" }}>
						<h2>{props.title}</h2>
						{props.children}
					</div>
				</Box>
			</Modal>
		</div>
	);
};
